'use client';

import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { AnimatedButton } from '@/components/ui/animated-button';
import { ArrowRight01Icon } from '@/components/ui/icon/glyphs';

export function FundingExchangePicker({
  busy,
  onSelect,
}: {
  busy: boolean;
  onSelect(): void;
}): ReactNode {
  const t = useTranslations('onramp');
  return (
    <div className="flex flex-col gap-3">
      <AnimatedButton
        variant="tertiary"
        suffix={ArrowRight01Icon}
        disabled={busy}
        className="h-auto min-h-16.5 w-full justify-between rounded-control bg-background-tertiary p-3"
        onClick={onSelect}
      >
        <span className="flex items-center gap-3">
          <OptimizedImage
            // ALLOW-NSFW-FALSE: approved bundled payment artwork.
            nsfw={false}
            variant="thumbnail"
            // ALLOW-NO-PREVIEW: bundled decorative exchange artwork.
            preview={false}
            loadReveal="none"
            rounded=""
            imageClassName="object-contain"
            src="/assets/onramp/method-coinbase.png"
            alt=""
            size="size-10"
            className="bg-transparent"
          />
          <span className="flex flex-col items-start">
            <span className="text-body font-medium">{t('exchange_coinbase')}</span>
            <span className="text-caption text-foreground-secondary">
              {t('exchange_transfer_description')}
            </span>
          </span>
        </span>
      </AnimatedButton>
    </div>
  );
}
